import React from "react";
import Layout from "components/Layout";
import { getGlobals } from "lib/getGlobals";
import Header from "components/Header";
import Meta from "components/Meta";
import Image from "next/image";
import MenuToList from "components/Menu/MenuToList";

export default function SiteMapPage({ globals }) {
  const pageTitle = "Plan du site";
  const crumbs = [
    {
      path: "/",
      title: "Accueil",
    },
    {
      title: pageTitle,
    },
  ];

  return (
    <Layout globals={globals}>
      <Meta title={pageTitle} />
      <Header crumbs={crumbs} title={pageTitle} />
      <section className="pt-10 pb-48 overflow-hidden relative">
        <div
          className="absolute -left-60 top-1/2 -translate-y-1/4 scale-75 opacity-20"
          style={{
            width: "30vw",
            height: "30vw",
          }}
        >
          <Image
            src="/images/decorations/lightblue-martinique.svg"
            height={571}
            width={490}
            alt="Réprésentation de la Martinique"
          />
        </div>
        <div
          className="absolute -right-40 top-0 opacity-20"
          style={{
            width: "30vw",
            height: "30vw",
          }}
        >
          <Image
            src="/images/decorations/lightblue-mayotte.svg"
            height={571}
            width={490}
            alt="Réprésentation de mayotte"
          />
        </div>
        <div className="container mx-auto px-4 lg:max-w-screen-lg">
          <div className="prose">
            <h2>Menu principal</h2>
            <MenuToList menu={globals.menus.main} />
            <h2>Menu secondaire</h2>
            <MenuToList menu={globals.menus.footer} />
          </div>
        </div>
      </section>
    </Layout>
  );
}

export async function getStaticProps(context) {
  const globals = await getGlobals(context);

  return {
    props: {
      globals,
    },
    revalidate: 30,
  };
}
